const designPrices = [
  { designId: 487964, price: 9.0 },
  { designId: 487965, price: 9.0 },
  { designId: 487966, price: 9.0 },
  { designId: 487967, price: 9.0 },
  { designId: 487968, price: 9.0 },
  { designId: 487969, price: 9.0 },
  { designId: 487970, price: 9.0 },
  { designId: 487971, price: 9.0 },
  { designId: 487972, price: 9.0 },
  { designId: 487973, price: 9.0 },
  { designId: 487974, price: 9.0 },
  { designId: 487975, price: 9.0 },
  { designId: 487976, price: 9.0 },
  { designId: 487977, price: 9.0 },
  { designId: 487978, price: 9.0 },
  { designId: 487979, price: 9.0 },
  { designId: 487980, price: 9.0 },
  { designId: 487981, price: 9.0 },
  { designId: 487982, price: 9.0 },
  { designId: 487983, price: 9.0 },
  { designId: 487984, price: 9.0 },
  { designId: 487985, price: 9.0 },
  { designId: 487986, price: 9.0 },
  { designId: 487987, price: 9.0 },
  { designId: 487988, price: 4.56 },
  { designId: 487989, price: 4.27 },
  { designId: 487990, price: 9.0 },
  { designId: 487991, price: 4.56 },
  { designId: 487992, price: 9.0 },
  { designId: 487993, price: 9.0 },
  { designId: 487994, price: 4.56 },
  { designId: 487995, price: 4.27 },
  { designId: 487996, price: 4.27 },
  { designId: 487997, price: 4.28 },
  { designId: 487998, price: 4.28 },
  { designId: 487999, price: 9.0 },
  { designId: 488000, price: 4.06 },
  { designId: 488001, price: 9.0 },
  { designId: 488002, price: 4.37 },
  { designId: 488003, price: 4.37 },
  { designId: 488004, price: 4.56 },
  { designId: 488005, price: 4.56 },
  { designId: 488006, price: 4.56 },
  { designId: 488007, price: 4.37 },
  { designId: 488008, price: 4.37 },
  { designId: 488009, price: 4.37 },
  { designId: 488010, price: 4.28 },
  { designId: 488011, price: 4.37 },
  { designId: 488012, price: 9.0 },
  { designId: 488013, price: 9.0 },
  { designId: 488014, price: 4.37 },
  { designId: 488015, price: 4.37 },
  { designId: 488016, price: 4.56 },
  { designId: 488017, price: 4.56 },
  { designId: 488018, price: 4.27 },
  { designId: 488019, price: 4.37 },
  { designId: 488020, price: 6.0 },
  { designId: 488021, price: 6.0 },
  { designId: 488022, price: 6.0 },
  { designId: 488023, price: 6.0 },
  { designId: 488024, price: 4.37 },
  { designId: 488025, price: 4.56 },
  { designId: 488026, price: 9.0 },
  { designId: 488027, price: 4.37 },
  { designId: 488028, price: 4.24 },
  { designId: 488029, price: 4.24 },
  { designId: 488030, price: 9.0 },
  { designId: 488031, price: 4.56 },
  { designId: 488032, price: 4.37 },
  { designId: 488033, price: 4.37 },
  { designId: 488034, price: 4.56 },
  { designId: 488035, price: 4.56 },
  { designId: 488036, price: 4.37 },
  { designId: 488037, price: 4.56 },
  { designId: 488038, price: 4.37 },
  { designId: 488039, price: 4.56 },
  { designId: 488040, price: 4.37 },
  { designId: 488041, price: 4.27 },
  { designId: 488042, price: 4.37 },
  { designId: 488043, price: 4.27 },
  { designId: 488044, price: 4.37 },
  { designId: 488045, price: 4.27 },
  { designId: 488046, price: 4.37 },
  { designId: 488047, price: 4.28 },
  { designId: 488048, price: 4.06 },
  { designId: 488049, price: 4.28 },
  { designId: 488050, price: 4.06 },
  { designId: 488051, price: 4.56 },
  { designId: 488052, price: 4.37 },
  { designId: 488055, price: 4.56 },
  { designId: 488056, price: 4.37 },
  { designId: 488057, price: 4.06 },
  { designId: 488058, price: 4.06 },
  { designId: 488059, price: 4.56 },
  { designId: 488060, price: 4.37 },
  { designId: 488061, price: 4.56 },
  { designId: 488062, price: 4.37 },
  { designId: 488063, price: 4.56 },
  { designId: 488064, price: 4.37 },
];

export default designPrices;
